import { z } from "zod";
import { defineEvent } from "./registry.js";
/**
 * Bakım ve uyum olayları (Prompt 23, ADR 0023 §17). Yük KİŞİSEL VERİ TAŞIMAZ; web / mobil ayrıntıyı yetki denetimli API'den
 * çeker. İş emri olayları kiracı + istasyon odalarına, uyum olayları kiracı odasına gider.
 */
const workOrderStatus = z.enum(["OPEN", "ASSIGNED", "IN_PROGRESS", "ON_HOLD", "DONE", "CANCELLED"]);
export const maintenanceWorkOrderCreatedV1 = defineEvent({
    type: "maintenance.work_order.created",
    version: 1,
    description: "Bakım / arıza iş emri açıldı (elle, plandan ya da alarmdan)",
    realtime: ["tenant", "station"],
    payload: z.object({
        workOrderId: z.uuid(),
        stationId: z.uuid(),
        source: z.enum(["MANUAL", "PLAN", "ALARM"]),
        priority: z.enum(["LOW", "NORMAL", "HIGH", "URGENT"]),
    }),
});
export const maintenanceWorkOrderStatusChangedV1 = defineEvent({
    type: "maintenance.work_order.status_changed",
    version: 1,
    description: "İş emrinin durumu değişti (atandı, başladı, beklemede, tamamlandı, iptal)",
    realtime: ["tenant", "station"],
    payload: z.object({
        workOrderId: z.uuid(),
        stationId: z.uuid(),
        fromStatus: workOrderStatus,
        toStatus: workOrderStatus,
    }),
});
export const complianceDocumentChangedV1 = defineEvent({
    type: "compliance.document.changed",
    version: 1,
    description: "Uyum belgesi eklendi, yenilendi ya da arşivlendi",
    realtime: ["tenant"],
    payload: z.object({
        documentId: z.uuid(),
        stationId: z.uuid().nullable(),
        change: z.enum(["CREATED", "RENEWED", "ARCHIVED", "UPDATED"]),
    }),
});
//# sourceMappingURL=maintenance.v1.js.map